export default __webpack_public_path__ + "static/media/photo--lg--org-2.6598959e.jpg";